import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConversionTracking } from '@/components/analytics/ConversionTracking';
import { useVisitorTracking } from '@/hooks/useVisitorTracking';
import { productionLogger } from '@/utils/production-logger';

export const useAnalytics = () => {
  const location = useLocation();
  const tracking = useConversionTracking();
  
  // Initialize visitor tracking for first-party analytics
  useVisitorTracking();

  // Track page views
  useEffect(() => {
    // Google Analytics page view (handled automatically by gtag config)
    
    // Facebook Pixel page view (handled automatically by fbq)
    
  }, [location]);

  return tracking;
};